import { RouteRecordRaw } from "vue-router";
import { UsersPage } from "@/pages/users/index";
import { NotFoundPage } from "@/pages/404/index";
import { ForbiddenPage } from "@/pages/403/index";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/404",
    name: "404",
    component: NotFoundPage,
  },
  {
    path: "/403",
    name: "403",
    meta: { hideSidebar: true },
    component: ForbiddenPage,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "404",
  },
  {
    path: "/",
    redirect: "/users",
  },
  {
    path: "/users",
    name: "users",
    meta: { acl: ["admin"] },
    component: UsersPage,
  },
];
